import { useContext, useEffect } from 'react';
import { useNavigate } from '@tanstack/react-router';

import { useLogout } from '../model/auth.hooks';
import { clearPersistStorage } from '@shared/query-client';
import { AppContext } from '@/app.context';

export function Logout() {
	const navigate = useNavigate();
	const { clearCache } = useContext(AppContext);
	const isLoading = useLogout();
	useEffect(() => {
		if (!isLoading) {
			const promises: Array<Promise<unknown>> = [clearPersistStorage()];
			if (clearCache) {
				promises.push(clearCache());
			}
			Promise.all(promises)
				.then(() => {
					navigate({
						to: '/',
						replace: true,
					});
				})
				.catch(() => {
					navigate({
						to: '/',
						replace: true,
					});
				});
		}
	}, [isLoading, clearCache, navigate]);
	return <div />;
}

export default Logout;
